export const seatingData = () => {
  return [
    {
      title: `What if my account credit doesn't match what I want to pay this year?`,
      htmlDescription: `<p>If the credit on your account is greater than your Membership Level, you may use this additional credit to purchase game tickets at any time during the 2022 season. You may also choose to upgrade to the next Membership Level.</p>`,
    },
  ];
};
